module.exports = __webpack_public_path__ + "static/media/feishu2.d5cb8bd9.mp4";